(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game/assets/javascripts/views/level-select.js') >= 0) return;  svs.modules.push('/components/numbergames/game/assets/javascripts/views/level-select.js');

'use strict';

svs.numbergames.game.views.LevelSelect = Marionette.View.extend({
  viewOptions: ['levels'],
  levels: {},
  className() {
    const brandingSuffix = svs.numbergames.productMapping.getBrandingClass(this.model.get('productId'));
    return "numbergames-level-select numbergames-level-select-".concat(brandingSuffix);
  },
  regions: {
    levelHeaderRegion: '#levelHeaderRegion'
  },
  ui: {
    levelRadio: '.js-level-radio'
  },
  triggers: {
    'change @ui.levelRadio': 'changeLevel'
  },
  modelEvents: {
    'number:added number:removed numbers:removed:all': 'toggleLevels'
  },
  behaviors: [{
    behaviorClass: svs.numbergames.core.behaviors.BindViewRadio,
    channel: svs.numbergames.game.huxfluxRadio
  }],
  radioEvents: {
    'huxflux:start': 'huxfluxStart',
    'huxflux:end': 'toggleLevels'
  },
  template(data) {
    return svs.numbergames.game.templates.level_select(data);
  },
  templateContext() {
    const numbersLength = this.model.get('numbers').length;
    const isSystem = this.model.get('isSystem');
    return {
      levels: this.levels,
      isDisabled: level => !isSystem && level < numbersLength
    };
  },
  initialize() {
    this.mergeOptions(this.options, this.viewOptions);
    if (!this.model.get('level')) {
      this.model.set({
        level: this.levels.preset
      });
    }
  },
  onRender() {
    this.showChildView('levelHeaderRegion', new svs.numbergames.game.views.LevelHeader({
      model: this.model
    }));
  },
  onChangeLevel(view, event) {
    const level = parseInt(event.target.value, 10);
    this.model.set({
      level
    });
  },
  huxfluxStart() {
    const selectedLevel = this.model.get('level');
    this.getUI('levelRadio').each((i, item) => {
      item.disabled = item.value !== selectedLevel;
    });
  },
  toggleLevels() {
    const numbersLength = this.model.get('numbers').length;
    const isSystem = this.model.get('isSystem');
    this.getUI('levelRadio').each((i, item) => {
      item.disabled = !isSystem && item.value < numbersLength;
    });
  }
});

 })(window);